module.exports = __webpack_public_path__ + "static/code-styled-eadd7b1ef0f66672cb7a7fcde32efe79.png";